import React, {KeyboardEventHandler, useState} from "react";
import CreatableSelect from "react-select/creatable";

const components = {
    DropdownIndicator: null,
};

interface Option {
    readonly label: string;
    readonly value: string;
}

const createOption = (label: string): Option => ({
    label,
    value: label,
});

interface MultiTextInputProps {
    value: string[];
    onChange: (value: string[]) => void;
    onBlur?: () => void;
    placeholder?: string;
    invalid?: boolean;
    disabled?: boolean;
}

const MultiTextInput: React.FC<MultiTextInputProps> = ({
                                                           value,
                                                           onChange,
                                                           onBlur,
                                                           placeholder = "Type something and press enter...",
                                                           invalid,
                                                           disabled = false,
                                                       }) => {
    const [inputValue, setInputValue] = useState("");

    const addValue = () => {
        const v = inputValue.trim();
        if (v && !value.includes(v)) onChange([...value, v]);
        setInputValue("");
    };

    const handleKeyDown: KeyboardEventHandler = (event) => {
        if (!inputValue) return;
        switch (event.key) {
            case "Enter":
            case "Tab":
                addValue();
                event.preventDefault();
        }
    };

    const inputChangeHandle = (newValue: string, meta: any) => {
        if (meta.action === "input-change") setInputValue(newValue);
    }

    const handleBlur = () => {
        addValue();
        onBlur?.();
    };

    return (
        <CreatableSelect
            className="react-select-container"
            classNamePrefix="react-select"
            components={components}
            inputValue={inputValue}
            isClearable
            isMulti
            isDisabled={disabled}
            menuIsOpen={false}
            onChange={(newValue) => onChange(newValue.map(o => o.value))}
            onInputChange={inputChangeHandle}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            placeholder={placeholder}
            value={value.map(createOption)}
            styles={{
                control: (base) =>
                    invalid ? {...base, borderColor: "#dc3545", "&:hover": {borderColor: "#dc3545"}} : base
            }}
        />
    );
};

export default MultiTextInput;